module.exports = __webpack_public_path__ + "NoeDisplay-Bold.b7c2c68d7ec396f34a7a.svg";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/NoeDisplay-Bold/NoeDisplay-Bold.svg
// module id = ../../../../../src/assets/fonts/NoeDisplay-Bold/NoeDisplay-Bold.svg
// module chunks = styles